import React, { ReactNode } from 'react';
import styled from 'styled-components';

const RowWrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

export const ColWrap = styled.div<{ size: string; col: number | undefined }>`
    width: ${({ size }) => size};
    flex: ${({ col }) => col || 'none'};
    height: 100%;
`;

interface PropsRow {
    children: ReactNode;
}

const Row = (props: PropsRow) => {
    return (
        <div style={{ clear: 'both' }}>
            <RowWrap>{props.children}</RowWrap>
        </div>
    );
};

interface PropsCol {
    children: ReactNode;
    size?: string;
    col?: number;
}

const Col = (props: PropsCol) => {
    const { size, children, col } = props;

    let exactSize = '100%';
    if (size !== undefined) {
        exactSize = size + '%';
    }

    return (
        <ColWrap size={exactSize} col={col}>
            {children}
        </ColWrap>
    );
};

export { Row, Col };
